































































import { Component, Prop } from 'vue-property-decorator';
import { FeedbackModel, IAnnouncement } from 'admiral-core';
import { XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import MdComponent from '@/components/common/MdComponent.vue';
import FeedbackForm from '@/forms/FeedbackForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import { FeedbackApi } from '@/services/FeedbackApi';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';

@Component({
  components: {
    MdComponent,
    XIcon,
    FeedbackForm,
    FormSubmit,
  },
})
export default class AnnouncementModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ required: false })
  announcement!: IAnnouncement;

  isLoading = false;
  isDone = false;

  feedback: FeedbackModel = {
    rating: 0,
    comment: '',
    announcement: this.announcement,
  };

  async sendFeedback() {
    try {
      this.isLoading = true;
      await FeedbackApi.create({
        rating: this.feedback.rating || 0,
        comment: this.feedback.comment || '',
        announcementId: this.announcement.id,
      });
      this.isDone = true;
      this.$toastr.s('Feedback erfolgreich gespeichert.', 'Super');
    } catch (error) {
      this.$toastr.e('Beim Speichern des Feedbacks ist etwas schief gelaufen.', 'Oops');
    } finally {
      this.isLoading = false;
    }
  }

  cancel() {
    //
  }
}
